import React from 'react';
import { Feature } from '@/store/Reducers/featureUpdatesReducer';
import Chip from 'ui/chip';
import { HugeiconsIcon } from '@hugeicons/react';
import {
  SparklesIcon,
  DashboardBrowsingIcon,
  Database01Icon,
  Settings02Icon,
  Notification03Icon,
  Video02Icon,
  PencilEdit02Icon,
} from '@hugeicons/core-free-icons';

const categoryConfig: Record<string, { label: string; color: 'primary' | 'success' | 'warning' | 'danger' | 'default'; icon: any; iconColor: string; bgColor: string }> = {
  ai_tools: { label: 'AI Tools', color: 'primary', icon: SparklesIcon, iconColor: '#5579F2', bgColor: 'rgba(85,121,242,0.1)' },
  dashboard: { label: 'Dashboard', color: 'success', icon: DashboardBrowsingIcon, iconColor: '#10B981', bgColor: 'rgba(16,185,129,0.1)' },
  data: { label: 'Data', color: 'warning', icon: Database01Icon, iconColor: '#F5A524', bgColor: 'rgba(245,165,36,0.1)' },
  fgd_idi: { label: 'FGD / IDI', color: 'danger', icon: Video02Icon, iconColor: '#EF4444', bgColor: 'rgba(239,68,68,0.1)' },
  question_builder: { label: 'Question Builder', color: 'primary', icon: PencilEdit02Icon, iconColor: '#8B5CF6', bgColor: 'rgba(139,92,246,0.1)' },
  settings: { label: 'Settings', color: 'default', icon: Settings02Icon, iconColor: '#9e9e9e', bgColor: 'rgba(158,158,158,0.1)' },
  general: { label: 'General', color: 'default', icon: Notification03Icon, iconColor: '#9e9e9e', bgColor: 'rgba(158,158,158,0.1)' },
};

const FeatureItem = ({ feature }: { feature: Feature }) => {
  const config = categoryConfig[feature.category || 'general'] || categoryConfig.general;

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div
      className={`flex gap-3 p-3 rounded-lg transition-all duration-200 hover:bg-background-color ${
        !feature.seen ? 'border-l-[3px] border-l-primary bg-primary/[0.02]' : 'border-l-[3px] border-l-transparent'
      }`}
    >
      {/* Icon */}
      <div
        className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
        style={{ backgroundColor: config.bgColor }}
      >
        <HugeiconsIcon
          icon={config.icon}
          size={16}
          color={config.iconColor}
          strokeWidth={1.5}
        />
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-0.5">
          <span className="text-sm font-semibold text-primary-text-color truncate">
            {feature.title}
          </span>
          {!feature.seen && (
            <Chip variant="flat" color="primary" size="sm" className="text-[10px] h-4">
              NEW
            </Chip>
          )}
        </div>
        <p className="text-xs text-default-text-color line-clamp-1 leading-relaxed">
          {feature.description}
        </p>
        <div className="flex items-center gap-2 mt-1.5">
          {feature.category && (
            <Chip variant="flat" color={config.color} size="sm" className="text-[10px] h-4 capitalize">
              {config.label}
            </Chip>
          )}
          <span className="text-[10px] text-default-text-color">
            {formatDate(feature.createdAt)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default FeatureItem;
